import { BodyEncoder } from '@iotize/tap/client/api';
import { Buffer, TranscodeEncoding } from 'buffer';

export class StringConverter
  implements BodyEncoder<string>, BodyEncoder<string>
{
  private static _ascii?: StringConverter = undefined;

  constructor(
    public encoding: TranscodeEncoding = 'ascii',
    public options: {
      /**
       * Returns string without content after the end of string character '\0'
       * 'Hello World!\u0001\u0001\u0001' will returns 'Hello World!'
       */
      stripEndOfStringCharacter?: boolean;
      /**
       * Replace empty string with '\0'
       */
      replaceEmptyStringWithEndOfLineChar?: boolean;
      /**
       * true if end of string character should be added when encoding value
       */
      addEndOfStringCharacter?: boolean;
    } = {
      stripEndOfStringCharacter: true,
      replaceEmptyStringWithEndOfLineChar: false,
      addEndOfStringCharacter: false,
    },
  ) {}

  encode(value: string): Uint8Array {
    if (typeof value === 'number') {
      value = (value as number).toString();
    }
    if (typeof value !== 'string') {
      value = '';
    }
    if (this.options.addEndOfStringCharacter) {
      value += '\0';
    } else if (!value && this.options.replaceEmptyStringWithEndOfLineChar) {
      return Uint8Array.from([0]);
    }
    let buffer = Buffer.from(value, this.encoding);
    return Uint8Array.from(buffer);
  }

  decode(value: Uint8Array): string {
    let str = Buffer.from(value).toString(this.encoding);
    if (this.options.stripEndOfStringCharacter) {
      const indexOfEndOfString = str.indexOf('\0');
      if (indexOfEndOfString >= 0) {
        str = str.substring(0, indexOfEndOfString);
      }
    }
    return str;
  }

  /**
   * Get ascii instance
   * @deprecated use constructor instead
   */
  public static ascii() {
    if (!StringConverter._ascii) {
      StringConverter._ascii = new StringConverter('ascii', {
        replaceEmptyStringWithEndOfLineChar: true,
        stripEndOfStringCharacter: true,
      });
    }
    return StringConverter._ascii;
  }
}
